import {API_URL_USERS} from '../constants';

export const apiBaseEditInfo = {
  baseUrl: API_URL_USERS,
  endpoints: {
    resolveEmail: '/edit-info/v2/teen/resolve-email',
  },
};
